const getCustomerId = () => {
    const url = new URL(window.location.href);
    return url.searchParams.get('customer_id');
}
export default getCustomerId;